<template>
  <v-card flat>
    <v-card-title>Login</v-card-title>
    <hr />
    <v-card-text>
      <v-simple-table class="table">
        <template v-slot:default>
          <tbody>
            <tr>
              <td>HTTP Method :</td>
              <td>POST</td>
            </tr>
            <tr>
              <td>URL :</td>
              <td>
                <a :href="url + restUrl" target="_blank">{{url +restUrl}}</a>
              </td>
            </tr>
            <tr>
              <td>Description :</td>
              <td>The Login function is used to get an authorization token based on the UserName and Password.</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-title>Request Parameters:</v-card-title>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Parameter Name</th>
              <th class="text-left">Description</th>
              <th class="text-left">Parameter Type</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>UserName</td>
              <td>Username to get token</td>
              <td>body</td>
            </tr>
            <tr>
              <td>Password</td>
              <td>Password of GeoAd API</td>
              <td>body</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-title>JSON Request:</v-card-title>
    <v-card-text>
      <code v-html="jsonRequest" />
    </v-card-text>

    <v-card-title>JSON Response:</v-card-title>
    <v-card-text>
      <code v-html="jsonToken" />
    </v-card-text>
    <v-card-text>
      <ul>
        <li>
          <b>JSON</b> “Token”
          <b>value:</b>
          In this function Login function response is JSON Token field is encrypted: <b>"xxxyyyzzz"</b>
        </li>
        <li>This is an encrypted value of token.</li>
      </ul>
    </v-card-text>
    <br />
  </v-card>
</template>

<script>
export default {
  data: () => ({
    url: process.env.VUE_APP_BASE_URL,
    restUrl: "Login",
    jsonRequest: {
      UserName: "xx",
      Password: "yy"
    },
    jsonToken: {
      Token: "xxxyyyzzz"
    }
  })
};
</script>
